/** Standalone page generated by scripts/sync-docs.js from the topcon-ai-core source */
export const SUPPORT_BRIEFINGS_URL = "/docs/SUPPORT-BRIEFINGS.html";

/** Text only the briefing page has: a missing file falls back to the SPA's index.html, which lacks it */
const SUPPORT_BRIEFINGS_MARKER = "const BRIEFINGS";

/** Widest interval the summary accepts, in version lines (1.106 + 1.107) */
export const MAX_RANGE_LINES = 2;

/**
 * Hash that opens the briefing page on the summary of an interval. One version is an interval
 * that starts and ends on it.
 */
export function supportRangeHash(from: string, to: string): string {
  return `range-${from}-${to}`;
}

/**
 * Fetches the briefing page and lists the version lines it documents ("1.107").
 * @returns The lines, or null when the page is not published in this build
 */
export async function fetchSupportBriefingLines(): Promise<string[] | null> {
  try {
    const response = await fetch(SUPPORT_BRIEFINGS_URL);

    if (!response.ok) return null;

    const html = await response.text();

    if (!html.includes(SUPPORT_BRIEFINGS_MARKER)) return null;

    const lines: string[] = [];
    const regex = /\bid: "(\d+)-(\d+)"/g;
    let match = regex.exec(html);

    while (match !== null) {
      lines.push(`${match[1]}.${match[2]}`);
      match = regex.exec(html);
    }

    return lines;
  } catch (err) {
    return null;
  }
}
